import ka from '../../assets/members/ka.jpeg';
import Sec from '../../assets/members/Newsec.png';
import Ex_2 from '../../assets/members/pra.jpeg';
import Ex_3 from '../../assets/members/oj.jpeg';
import Ex_4 from '../../assets/members/ch.jpeg';
import vp from '../../assets/members/vp.jpeg';
import mb from '../../assets/members/mb.jpeg';
import vb from '../../assets/members/vb.jpeg';
import thea from '../../assets/members/Thea.jpeg';
import sb from '../../assets/members/sb.jpeg';
import ex from '../../assets/members/ex.jpeg';
import kv from '../../assets/members/kv.jpeg';
import pv from '../../assets/members/pv.jpeg';
import ut from '../../assets/members/Innovative Head.jpeg';
import sg from '../../assets/members/sg.jpeg';
import nk from '../../assets/members/nk.jpeg';
import sk from '../../assets/members/sk.jpeg';

export const members = [
    {
        id: 1,
        name: 'Kashvi Arora',
        post: 'President',
        img: ka
    },
    
    {
        id: 2,
        name: 'Shubham Katoch',
        post: 'Vice President',
        img: sk
    },
        {
        id: 3,
        name: 'Khushi Piplani',
        post: 'Vice President ',
        img: vp
    },
    {
        id: 4,
        name: 'Ekagra Singh',
        post: 'Secretary',
        img: Sec
    },
        {
        id: 5,
        name: 'Shashank Bansal',
        post: 'Assistant Secretary',
        img: sb
    },
     
        {
        id: 6,
        name: 'Uttkarsh Miglani',
        post: 'Club-Mentor',
        img: ut
    },
     
        {
        id: 7,
        name: 'Kanishq Verma',
        post: 'Club-Mentor',
        img: kv
    
     },
        {
        id: 8,
        name: 'Nirvaan Katyal',
        post: 'Club Mentor',
        img: nk
    },
    
    {
        id: 9,
        name: 'Shaurya Gupta',
        post: 'Innovation Head',
        img: sg
        },
   
    {
        id: 10,
        name: 'Thea Girotra',
        post: 'Activity Cooridinator',
        img: thea
    },
    {
        id: 11,
        name: 'Vansh Bhardwaj',
        post: 'Activity Cooridinator',
        img: vb
    },
     {
        id: 12,
        name: 'Ojas Harish',
        post: 'Executive Member',
        img: Ex_3
    },
     {
        id: 13,
        name: 'Pratishtha Vohra',
        post: 'Executive Member',
        img: pv
    },
     {
        id: 14,
        name: 'Manik Bakshi',
        post: 'Executive Member',
        img: mb
    },
     {
        id: 15,
        name: 'Aayush Sharma',
        post: 'Executive Member',
        img: ex
    },
     {
        id: 16,
        name: 'Prarthna Punpher',
        post: 'Executive Member',
        img: Ex_2
    },
     {
        id: 17,
        name: 'Chaitanya Palta',
        post: 'Innovative Head',
        img: Ex_4
    },
]



export const years = [
    {
        id: 1,
        year: '2017-18',
        President: 'Devansh Srivastav',
        Vice_President: 'Jaydeep',
    },
    {
        id: 2,
        year: '2018-19',
        President: 'Priyansh Bahuguna',
        Vice_President: 'Shivansh Grover',
    },
    {
        id: 3,
        year: '2019-20',
        President: 'Siddharth Pal',
        Vice_President: 'Sarthak Kumar',
    },
    {
        id: 4,
        year: '2020-21',
        President: 'Lakshit Bakshi',
        Vice_President: 'Khushi Setia',
    },
    {
        id: 5,
        year: '2021-22',
        President: 'Naman Arora',
        Vice_President: 'Kashvi Arora ',
    }
]
